import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Checkbox } from "../ui/checkbox";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function ComponentModal({ open, onClose, onSuccess, sdpId, token }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    codigo: "",
    descricao: "",
    quantidade: 1,
    unidade: "UN",
    item_existente: false,
    observacoes: ""
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/sdp/${sdpId}/components`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Componente adicionado!");
      onSuccess();
      setFormData({
        codigo: "",
        descricao: "",
        quantidade: 1,
        unidade: "UN",
        item_existente: false,
        observacoes: ""
      });
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao adicionar componente");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Adicionar Componente</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label>Codigo</Label>
              <Input
                value={formData.codigo}
                onChange={(e) => setFormData(prev => ({ ...prev, codigo: e.target.value }))}
                placeholder="Ex: 8-099-12345"
              />
            </div>
            <div>
              <Label>Descricao *</Label>
              <Input
                value={formData.descricao}
                onChange={(e) => setFormData(prev => ({ ...prev, descricao: e.target.value }))}
                required
                placeholder="Descricao do item..."
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label>Quantidade</Label>
              <Input
                type="number"
                value={formData.quantidade}
                onChange={(e) => setFormData(prev => ({ ...prev, quantidade: parseInt(e.target.value) || 1 }))}
              />
            </div>
            <div>
              <Label>Unidade</Label>
              <Select value={formData.unidade} onValueChange={(v) => setFormData(prev => ({ ...prev, unidade: v }))}>
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="UN">UN</SelectItem>
                  <SelectItem value="KG">KG</SelectItem>
                  <SelectItem value="M">M</SelectItem>
                  <SelectItem value="L">L</SelectItem>
                  <SelectItem value="CJ">CJ</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <Checkbox
              id="item_existente"
              checked={formData.item_existente}
              onCheckedChange={(c) => setFormData(prev => ({ ...prev, item_existente: c }))}
            />
            <Label htmlFor="item_existente" className="font-normal">
              Item ja existe no catalogo
            </Label>
          </div>
          <div>
            <Label>Observacoes</Label>
            <Textarea
              value={formData.observacoes}
              onChange={(e) => setFormData(prev => ({ ...prev, observacoes: e.target.value }))}
              rows={2}
              placeholder="Observacoes adicionais..."
            />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>Cancelar</Button>
            <Button type="submit" disabled={loading}>
              {loading ? "Adicionando..." : "Adicionar"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
